import { render, staticRenderFns } from "./DoneTasks.vue?vue&type=template&id=b3185e62&scoped=true&"
import script from "./DoneTasks.vue?vue&type=script&lang=js&"
export * from "./DoneTasks.vue?vue&type=script&lang=js&"
import style0 from "./DoneTasks.vue?vue&type=style&index=0&id=b3185e62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3185e62",
  null
  
)

export default component.exports